module.exports = __webpack_public_path__ + "img/logo_text.f52ff06c.png";